import CloseIcon from "@/assets/images/icons/close.svg?inline";

import { CHECK_PURCHASE, PURCHASE } from "../../../gql/AgentProfileQueries";

export default {
  name: "buy-lead-button",

  data() {
    return {
      isChecking: false,
      checkPurchase: {},
      skipCheckPurchaseQuery: true,
      submitPurchaseLoading: false,
      isBuyingContent: true,
      isGoToMessages: false
    };
  },

  props: ["lead"],

  apollo: {
    checkPurchase: {
      query: CHECK_PURCHASE,
      variables() {
        return {
          buyerId: this.lead.id,
          promoCode: ""
        };
      },
      skip() {
        return this.skipCheckPurchaseQuery;
      },
      result({ data: { checkPurchase } }) {
        if (checkPurchase.needPurchase) {
          this.$router.push({
            name: "lead",
            params: { id: this.lead.id, lead: this.lead }
          });
        } else {
          this.isChecking = false;
          this.showBuyLeadModal();
        }
        this.skipCheckPurchaseQuery = true;
      }
    }
  },

  methods: {
    checkPurchaseLead() {
      this.isChecking = true;
      this.skipCheckPurchaseQuery = false;
    },

    showBuyLeadModal() {
      this.$refs.aproveBuyLeadModal.show();
    },

    hideBuyLeadModal() {
      this.$refs.aproveBuyLeadModal.hide();
    },

    aproveBuyLead() {
      this.submitPurchaseLoading = true;
      this.$apollo
        .mutate({
          mutation: PURCHASE,
          variables: {
            buyerId: this.lead.id,
            price: this.checkPurchase.price,
            promoCodeDiscount: this.checkPurchase.promoCodeDiscount,
            promoCode: this.promoCode,
            pretiisCredits: this.checkPurchase.pretiisCredits,
            total: this.checkPurchase.total
          }
        })
        .then(() => {
          this.isBuyingContent = false;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;
          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitPurchaseLoading = false;
        });
    },

    updateLeadsPage() {
      this.$emit("updateLeadsList");

      this.isGoToMessages = true;

      setTimeout(() => {
        this.$router.push({
          name: "messages"
        });
      }, 2000);
    }
  },

  components: {
    CloseIcon
  }
};
